"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.POST_SECTION_TYPES = void 0;
exports.POST_SECTION_TYPES = {
    APARTMENT_INFO: 'apartment_info',
    COMMERCIAL_INFO: 'commercial',
    HOUSE_INFO: 'house',
    BUILDING_INFO: 'building_info',
    MORTGAGE_INFO: 'mortgage_info',
};
